export const HTTP_STATUS_MAP = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  NOT_AUTHORIZED: 401,
} as const
